import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { STORAGE_PREFIX } from '../../config/env';

interface EstadoDemo {
  ocultar: boolean;
  establecer: (ocultar: boolean) => void;
}

/**
 * Preferencia de ocultar el cliente de demostración.
 *
 * Arranca apagado: esconder datos por defecto sorprende a quien no sabe que
 * existe el conmutador, y hace pensar que faltan registros.
 */
export const useDemoStore = create<EstadoDemo>()(
  persist(
    (set) => ({
      ocultar: false,
      establecer: (ocultar) => set({ ocultar }),
    }),
    {
      name: `${STORAGE_PREFIX}ocultar-demo`,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
